module.exports = __webpack_public_path__ + "cacc4de9fd7e3c420f055730f8fe441d.png";